export default {
  setLoadingCount(state, count) {
    const tmpVal = (state.loadingCount += count);
    tmpVal < 0 ? (state.loadingCount = 0) : (state.loadingCount = tmpVal);
  },
  setLoadingFinish(state, status) {
    state.loadingFinish = status;
  },
  // 設定State資料
  setStateData(state, { key, val }) {
    state[key] = val;
  },
  // 設定Dialog狀態與內容文字
  setDialog(state, { status, content }) {
    state.mainDialog.status = status;
    state.mainDialog.content = content;
  },
  // 設定加入購物車訊息狀態
  setShopCartMessageShowCount(state, action) {
    if (state.shopCartMessageShowCount + action <= 0) {
      state.shopCartMessageShowCount = 0;
    } else {
      state.shopCartMessageShowCount += action;
    }
  },
};
